/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_AutoInputs */

const en_us2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic`)
};

const pt_br2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const es_419_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automática`)
};

const pt_pt2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automática`)
};

const fr_fr2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatique`)
};

const de_de2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch`)
};

const it_it2_profile_editors_split_auto = /** @type {(inputs: Profile_Editors_Split_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatico`)
};

/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Profile_Editors_Split_AutoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_auto = /** @type {((inputs?: Profile_Editors_Split_AutoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_AutoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_auto(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_auto(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_auto(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_auto(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_auto(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_auto(inputs)
	return en_us2_profile_editors_split_auto(inputs)
});
export { profile_editors_split_auto as "profile-editors.split_auto" }